import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
  selector: '[selectRequired]',
  providers: [{provide: NG_VALIDATORS, useExisting: SelectRequiredDirective, multi: true}]
})
export class SelectRequiredDirective implements Validator {
  
  
  validate(c: FormControl): {[key: string]: any} {
      let v = c.value;
      return ( v=="0" || v==0 )? {"selectRequired": true} : null;
  }
} 


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Directives/select-required.directive.ts